import { render, staticRenderFns } from "./CreationServiceName.vue?vue&type=template&id=fc2329a6&scoped=true&"
import script from "./CreationServiceName.vue?vue&type=script&lang=js&"
export * from "./CreationServiceName.vue?vue&type=script&lang=js&"
import style0 from "./CreationServiceName.vue?vue&type=style&index=0&id=fc2329a6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2329a6",
  null
  
)

export default component.exports